import { Directive, ElementRef, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[customCell]',
  standalone: true,
  host: {},
})
export class CustomCellDirective {
  @Input('customCell') customCell: string = '';

  constructor(private el: TemplateRef<any>) {}
}
